export default __webpack_public_path__ + "static/media/black-freehand-polygon-measure-icon.a8de44db.svg";